<template>
  <div class="contain">
    <div style="padding: 20px">
      <div class="footer-contain">
        <div class="index-footerb">
          <logoShow></logoShow>
        </div>
        <div class="index-footerb">
          <div class="index-footerc-a">青岛汇东橡塑有限公司</div>
          <h1>打造全新粘弹性发泡沫材料</h1>
        </div>
        <div class="index-footerb" style="position: relative">
          <div class="index-footerc-a">
            <img loading="lazy" :src="phone" />
            <span>服务热线</span>
          </div>
          <h1 class="phone-num-show">18661793901</h1>
          <h1 class="phone-num-show phone2" style="position: absolute;font-size: 20px;width: 200px;top: 75px">0532-86810808</h1>
        </div>
        <div class="index-footerb">
          <div class="index-footerc-a">
            <img loading="lazy" :src="marker" />
            <span>办公地址</span>
          </div>
          <h1>青岛西海岸新区辛安街道前湾港西路辛安工业园11号</h1>
        </div>
        <div class="index-footerb">
          <div class="index-footerc-a">
            <img loading="lazy" :src="email" />
            <span>服务邮箱</span>
          </div>
          <h1>hdxs@hdxs-qd.com</h1>
        </div>
        <!-- <div class="index-footerb">
          <div class="index-footerc-a">
            <img loading="lazy" :src="guanzhu" />
            <span>关注汇东</span>
          </div>
          <div class="icon-contain">
            <div class="guanzhu-show">
              <a href="#">
                <img loading="lazy" :src="wx" />
                <div class="qr-code">
                  <img loading="lazy" :src="wei" />
                </div>
              </a>
            </div>
            <div class="guanzhu-show">
              <a href="#">
                <img loading="lazy" :src="tiktok" />
                <div class="qr-code">
                  <img loading="lazy" :src="wei" />
                </div>
              </a>
            </div>
            <div class="guanzhu-show">
              <a href="#">
                <img loading="lazy" :src="wb" />
                <div class="qr-code">
                  <img loading="lazy" :src="wei" />
                </div>
              </a>
            </div>
          </div>
        </div> -->
      </div>
      <div class="link-show">
        <!--        <h1><a href="https://www.huaxia.net.cn" target="_blank" rel="noopener noreferrer">技术支持：华夏商务网</a></h1>-->
        <h2>Copyright © 2023 青岛汇东橡塑有限公司</h2>
        <h2>鲁ICP备2025173016号</h2>
      </div>
    </div>
  </div>
</template>
<script>
  import logoShow from '../components/logoShow';
  import phone from '@/assets/imgs/baseIcon/phone.png';
  import email from '@/assets/imgs/baseIcon/email.png';
  import marker from '@/assets/imgs/baseIcon/marker.png';
  import guanzhu from '@/assets/imgs/baseIcon/guanzhu.png';
  import wx from '@/assets/imgs/baseIcon/wx.png';
  import wei from '@/assets/imgs/baseIcon/wei.png';
  import wb from '@/assets/imgs/baseIcon/wb.png';
  import tiktok from '@/assets/imgs/baseIcon/tiktok.png';
  export default {
    name: 'myfooter',
    components: { logoShow },
    data() {
      return {
        phone,
        email,
        marker,
        guanzhu,
        wx,
        wei,
        tiktok,
        wb
      };
    },
    methods: {},
    created() {}
  };
</script>
<style lang="less" scoped>
  .contain {
    background: #fff;
    margin-top: 30px;
  }
  ::v-deep .ant-layout-footer {
    background: #fff;
  }
  .footer-contain {
    padding: 70px 0 50px 0;
    margin: 0 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: left;
    border-bottom: 2px solid #e5e5e5;
    > .index-footerb {
      // flex: 1;
      .index-footerc-a {
        position: relative;
        font-size: 18px;
        color: rgb(108, 109, 112);
        font-weight: bold;
        line-height: 1.667;
        > span {
          margin-left: 10px;
        }
        .phone2 {
          width: 200px;
          position: absolute !important;
          font-size: 14px !important;
        }
      }
      .phone-num-show {
        font-size: 22px;
        font-family: 'DIN';
        color: rgb(215, 184, 130);
        font-weight: bold;
        line-height: 1.364;
        // margin-left: 10px;
      }
      h1 {
        font-size: 16px;
        color: rgb(108, 109, 112);
        line-height: 1.875;
        margin: 10px 0;
        // margin-left: 30px;
      }
      h1::after {
        background: #d7b882;
        width: 12px;
        height: 2px;
        content: '';
        display: block;
        margin-top: 3px;
      }
    }
  }
  .icon-contain {
    display: flex;
    margin: 10px 0;
  }
  .guanzhu-show {
    position: relative;
    width: 55px;
    height: 55px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #e6e7e9;
    border-radius: 50%;
    margin-right: 10px;
  }
  .guanzhu-show:hover {
    background: #d30723;
  }
  .qr-code {
    display: none;
    position: absolute;
    bottom: 60px;
    right: -20px;
  }
  .guanzhu-show:hover .qr-code {
    display: block;
  }
  .link-show {
    margin: 0 40px;
    a {
      font-size: 14px;
      // font-weight: bold;
      color: rgba(0, 0, 0, 0.85);
    }
    a:hover {
      color: #d7b882;
    }
    h2 {
      font-size: 14px;
    }
  }
</style>
